<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

  <!-- Верхняя панель меню -->
  <header class="fixed top-0 left-0 right-0 z-10 shadow-sm">      
    <app-menu class="w-full"></app-menu>
  </header>

  <!-- Блок контента -->
  <main class="flex-1 overflow-auto mt-16 p-4 bg-[url(assets/img/bg2.jpg) cntr">
  <!-- <main class="mt-16 p-4 bg-[url(assets/img/bg2.jpg)]"> -->
        <router-outlet></router-outlet>
  </main>

  <!-- Футер -->
  <footer class="fixed bottom-0 left-0 right-0">
      <div class="w-full bg-zinc-100 flex justify-end">
        <a class="mr-2" role="button" tabindex="0" onclick="updateCache()"><b>Version</b> {{ version }} </a>
      </div>
  </footer>

<!-- <app-menu></app-menu>
<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div>
  <router-outlet></router-outlet>
</div> -->